import type { PriorityOption, SelectOption, Ticket } from '../../../types/support';
import type { SupportStatus } from './types';

export const supportPhone = {
  // display: '+7 (495) 137-00-27',
  // href: 'tel:+74951370027',
  display: '+7 (925) 147-83-91',
  href: 'tel:+79251478391',
  hours: 'По будням с 9:00 до 18:00 по московскому времени',
};

export const projectOptions: SelectOption[] = [
  { value: 'none', label: 'Другое' },
  { value: 'p22', label: 'проект 22 — Мебель для актового зала' },
  { value: 'p21', label: 'проект 21 — Компьютерная техника' },
  { value: 'p19', label: 'проект 19 — Учебное оборудование' },
  { value: 'p14', label: 'проект 14 — Расходные материалы' },
  { value: 'none', label: 'Проблема не связана с конкретным проектом' },
];

export const categoryOptions: SelectOption[] = [
  { value: 'other', label: 'Другое' },
  { value: 'auth', label: 'Вход и доступы' },
  { value: 'project', label: 'Создание и редактирование проекта' },
  { value: 'spec', label: 'Загрузка спецификации' },
  { value: 'search', label: 'Поиск и результаты подбора' },
  { value: 'analogs', label: 'Аналоги и КТРУ' },
  { value: 'suppliers', label: 'Поставщики и цены' },
  { value: 'reports', label: 'Аналитика и выгрузки' },
  { value: 'other', label: 'Другое' },
];

export const priorityOptions: PriorityOption[] = [
  { value: 'normal', label: 'Обычный', hint: 'Работа продолжается' },
  { value: 'high', label: 'Высокий', hint: 'Мешает выполнить задачу' },
  { value: 'critical', label: 'Критичный', hint: 'Работа полностью остановлена' },
];

export const responseTips = [
  { strong: 'Скриншот всего экрана', rest: ', а не одного окна — видно раздел и данные' },
  { strong: 'Точное время сбоя', rest: ' — по нему инженер находит запись в логах' },
  { strong: 'Текст ошибки целиком', rest: ', скопированный, а не пересказанный' },
  { strong: 'Шаги, которые её повторяют', rest: ' — что нажимали по порядку' },
];

export const DESCRIPTION_MAX = 2000;

export const statusLabels: Record<SupportStatus, string> = {
  new: 'Принято',
  run: 'В работе',
  done: 'Завершено',
};

export const SUPPORT_PROBLEMS = [
  'Проблема с авторизацией',
  'Требуется увеличение лимитов',
  'Проблема с загрузкой шаблона / добавлением товаров вручную',
  'Проблема с расчётом логистики',
  'Найдены некорректные цены / товары не соответствуют запросу',
  'Проблема со скриншотами',
  'Другое',
];

export const SUPPORT_PROBLEM_OPTIONS = SUPPORT_PROBLEMS.map((item) => ({
  id: item,
  name: item,
}));